import Footer from './footer';

export * from './footer';

export default Footer;
